import { AloftPrice } from '@aloft/toolkit-shared';

import { Value } from '../types.js';

export const getStringValue = (
  val: Value | Value[],
  options?: { noCommaInNumber: boolean },
): string => {
  if (typeof val === 'string') {
    return val;
  }

  if (typeof val === 'number') {
    if (options?.noCommaInNumber) {
      return val.toString();
    }
    return val.toLocaleString('en-us');
  }

  if (typeof val === 'boolean') {
    return val ? 'Yes' : 'No';
  }

  if (Array.isArray(val)) {
    return val.map((val) => getStringValue(val, options)).join(', ');
  }

  if (val instanceof AloftPrice) {
    return val.toString(true);
  }

  return '';
};
